import React, { Component } from 'react'
import {Http,urls} from '../../api/index'
class Store extends Component {
  componentDidMount() {
    let url = urls.findAdInfoList;
    Http.post({ url,data:{adCode:10002} }).then(res => {
      
    });
  }
  
  render() {
    return <div style={{height:'1000px'}} onClick={()=>this.props.history.goBack()}>store</div>
  }
}
export default Store;